import { Button, Card, Col, Popconfirm, Row, Space, Tag, Table, InputNumber, Drawer, Select, Switch } from 'antd'
import { TableColumnsType } from 'antd';
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { openNotification } from '../utils';
import { DeleteOutlined } from '@ant-design/icons'
import CourseService from '../services/CourseService';
import StudentService from '../services/StudentService';

interface Course {
  id: number;
  name: string;
  tags: string;
  description: string;
  salePrice: string;
  sortOrder: number;
  isActive: boolean;
}

const CourseList = () => {
  const [loading, setLoading] = useState(false);
  const [courseList, setCourseList] = useState<any[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [students, setStudents] = useState<any[]>([]);
  const [selectedStudentId, setSelectedStudentId] = useState<number | null>(null);
  const [selectedCourseId, setSelectedCourseId] = useState<number | null>(null);

  useEffect(() => {
    getCourseList()
  }, []);

  const columns: TableColumnsType<Course> = [
    {
      title: 'Sıralama',
      dataIndex: 'sortOrder',
      key: 'sortOrder',
      width: 80,
      render: (value, record: any) => (
        <InputNumber
          min={1}
          value={value}
          onBlur={(e) => handleSortOrderChange(record.id, Number(e.target.value))}
        />
      ),
    },
    {
      title: 'Kurs',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Ücret',
      dataIndex: 'salePrice',
      key: 'salePrice',
      render: (salePrice, record: any) =>
        record.free
          ? <b style={{ color: '#52c41a' }}>Ücretsiz</b>
          : <b>{salePrice} ₺</b>
    },
    {
      title: 'Popüler Kurs',
      dataIndex: 'popular',
      key: 'popular',
      render: (popular, record: any) =>
        popular
          ? <b style={{ color: '#52c41a' }}>Evet</b>
          : <b></b>
    },
    {
      title: 'Aktif',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean, record: Course) => (
        <Switch
          checked={isActive}
          onChange={(checked) => handleActiveStatusChange(record.id, checked)}
        />
      ),
    },
    {
      title: 'Komisyon Oranı',
      dataIndex: 'commissionRate',
      key: 'commissionRate',
      render: (commissionRate, record: any) =>
        record.free
          ? <span>-</span>
          : <b>% {commissionRate}</b>
    },
    {
      title: 'Ücretsiz Kursları',
      key: 'includedCourses',
      dataIndex: 'includedCourses',
      render: (includedCourses) => (
        <>
          {includedCourses && includedCourses.length > 0
            ? includedCourses.map((c: any) => (
              <Tag color="blue" key={c.id}>{c.name}</Tag>
            ))
            : <span>-</span>
          }
        </>
      ),
    },
    {
      title: 'Etiketler',
      key: 'tags',
      dataIndex: 'tags',
      render: (_, { tags }) => (
        <>
          {tags?.split(',').map((tag: any) => {
            return (
              <Tag key={tag}>
                #{tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'İşlem',
      align: "center",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button className='bg-saha-purple btn-hover-dark fw-700 font-color-white' onClick={() => showDrawer(record.id)}>
            Öğrenci
          </Button>
          <NavLink to={`/course/${record.id}`}>
            <Button className='bg-saha-purple btn-hover-dark fw-700 font-color-white'>
              Detay
            </Button>
          </NavLink>
          <Popconfirm
            key={record.id}
            title="Kurs silinsin mi?"
            onConfirm={() => removePackage(record.id)}
            okText="Evet"
            cancelText="Hayır"
          >
            <DeleteOutlined className='cursor-pointer' />
          </Popconfirm>
        </Space>
      ),
    },
  ];

const getCourseList = () => {
  setLoading(true);
  CourseService.getAll()
    .then((response: any) => {
      const data = response.data;

      const sortedData:any[] = [...data].sort((a, b) => {
        if (a.sortOrder === null) return 1;  // a null ise sona
        if (b.sortOrder === null) return -1; // b null ise sona
        return a.sortOrder - b.sortOrder;    // küçükten büyüğe
      });

      setCourseList(sortedData);
      setLoading(false);
    })
    .catch((e: Error) => {
      console.log(e);
      setLoading(false);
    });
};


  const removePackage = (id: number) => {
    CourseService.remove(id)
      .then((response: any) => {
        getCourseList();
        openNotification('success', 'Başarılı', 'Kurs Başarıyla Silindi.')
      }).catch((e: Error) => {
        openNotification('error', 'Başarısız', 'Kurs silinemedi.')
      });
  }

  const handleSortOrderChange = (id: number, sortOrder: number) => {
    CourseService.updateSortOrder(id, sortOrder)
      .then(() => {
        getCourseList();
      })
      .catch((e: Error) => {
        console.log(e);
        setLoading(false);
      });
  };

  const handleActiveStatusChange = (id: number, isActive: boolean) => {
    CourseService.updateActiveStatus(id, isActive)
      .then(() => {
        getCourseList();
        openNotification('success', 'Başarılı', `Kurs ${isActive ? 'aktif' : 'pasif'} duruma getirildi.`);
      })
      .catch(() => {
        getCourseList();
        openNotification('error', 'Başarısız', 'Kursun aktiflik durumu güncellenemedi.');
      });
  };

  const showDrawer = (courseId: number) => {
    setSelectedCourseId(courseId);
    setDrawerOpen(true);
    StudentService.getAll()
      .then((response: any) => {
        setStudents(response.data);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const onClose = () => {
    setDrawerOpen(false);
    setSelectedStudentId(null);
  };

  const handleAddStudent = () => {
    if (!selectedCourseId || !selectedStudentId) return;
    CourseService.addStudentForFree(selectedCourseId, selectedStudentId)
      .then(() => {
        openNotification('success', 'Başarılı', 'Öğrenci burslu eklendi.');
        onClose();
      })
      .catch(() => {
        openNotification('error', 'Başarısız', 'Öğrenci burslu eklenemedi.');
      });
  };

  return (
    <>
      <Card title="Kurs Listesi" extra={<NavLink to={'/course/create'}>
        <Button className='bg-saha-purple fw-700 font-color-white btn-hover-dark'>
          Yeni Kurs Oluştur
        </Button>
      </NavLink>}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Table<Course>
              columns={columns}
              dataSource={courseList}
              rowKey="id"
              pagination={false}
              scroll={{ x: 'max-content' }}
            />
          </Col>
        </Row>
      </Card>
      <Drawer title="Öğrenci Ekle" placement="right" onClose={onClose} open={drawerOpen}>
        <Select
          style={{ width: '100%', marginBottom: 16 }}
          placeholder="Öğrenci Seç"
          onChange={(value) => setSelectedStudentId(value)}
          value={selectedStudentId ?? undefined}
        >
          {students.map((s: any) => (
            <Select.Option key={s.id} value={s.id}>
              {s.firstName} {s.lastName}
            </Select.Option>
          ))}
        </Select>
        <Button type="primary" onClick={handleAddStudent} disabled={!selectedStudentId}>
          Ekle
        </Button>
      </Drawer>
    </>
  )
}

export default CourseList
